import { z } from "zod";

export const configSchema = z.object({
  filterFormData: z.object({
    searchName: z.string().optional(),
    sort: z.string().optional(),
    order: z.string().optional(),
    numberPerPage: z.number().optional(),
    pageIndex: z.number().optional(),
    sortBy: z.string().optional()
  }),
  conditionFormData: z.object({
    organizations: z.array(z.any()),
    healthIndex: z.array(z.any()),
    internalLabels: z.array(z.any())
  })
});

export type ConfigData = z.infer<typeof configSchema>;

export const defaultConfigData: ConfigData = {
  filterFormData: {
    searchName: "",
    sort: "name",
    order: "desc",
    numberPerPage: 20,
    pageIndex: 1,
    sortBy: "施設名 ↓"
  },
  conditionFormData: {
    organizations: [],
    healthIndex: [],
    internalLabels: []
  }
};
